export default __webpack_public_path__ + "static/skicka_faktura_miljo-e2ea2cdd5074fd1e2985afd596a020e8.png";